"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ScreenProvider_1 = require("src/contexts/ScreenProvider");
const SwapContext_1 = require("src/contexts/SwapContext");
const Form_1 = __importDefault(require("../../components/Form"));
const FormPairSelector_1 = __importDefault(require("../../components/FormPairSelector"));
const decimal_js_1 = __importDefault(require("decimal.js"));
const cn_1 = require("src/misc/cn");
const useBalances_1 = require("src/hooks/useBalances");
const useAsset_1 = require("src/hooks/useAsset");
const InitialScreen = () => {
    const { data: balances } = (0, useBalances_1.useBalances)();
    const { form, setForm, setErrors, quoteResponseMeta, loading, } = (0, SwapContext_1.useSwapContext)();
    const { setScreen } = (0, ScreenProvider_1.useScreenState)();
    const balance = (0, react_1.useMemo)(() => {
        var _a;
        if (!balances)
            return 0;
        return ((_a = balances[form.fromMint]) === null || _a === void 0 ? void 0 : _a.uiAmount) || 0;
    }, [balances, form.fromMint]);
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(false);
    const { data: asset } = (0, useAsset_1.useAsset)(form.fromMint);
    (0, react_1.useEffect)(() => {
        if (!form.fromValue || !form.fromMint || !form.toMint || !form.toValue || !quoteResponseMeta || loading) {
            setErrors({});
            setIsDisabled(true);
            return;
        }
        if (new decimal_js_1.default(form.fromValue).gt(balance)) {
            setErrors({
                fromValue: { title: `Insufficient ${asset === null || asset === void 0 ? void 0 : asset.symbol}`, message: '' },
            });
            setIsDisabled(true);
            return;
        }
        setErrors({});
        setIsDisabled(false);
    }, [form, asset, balance, quoteResponseMeta, loading, setErrors]);
    const [selectPairSelector, setSelectPairSelector] = (0, react_1.useState)(null);
    const onSelectMint = (0, react_1.useCallback)((tokenInfo) => __awaiter(void 0, void 0, void 0, function* () {
        if (selectPairSelector === 'fromMint') {
            setForm((prev) => (Object.assign(Object.assign(Object.assign({}, prev), { fromMint: tokenInfo.id, fromValue: '' }), (prev.toMint === tokenInfo.id ? { toMint: prev.fromMint } : undefined))));
        }
        else {
            setForm((prev) => (Object.assign(Object.assign(Object.assign({}, prev), { toMint: tokenInfo.id, toValue: '' }), (prev.fromMint === tokenInfo.id ? { fromMint: prev.toMint } : undefined))));
        }
        setSelectPairSelector(null);
    }), [selectPairSelector, setForm]);
    const onSubmitToConfirmation = (0, react_1.useCallback)(() => {
        setScreen('Swapping');
    }, [setScreen]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("form", { onSubmit: onSubmitToConfirmation, className: (0, cn_1.cn)({
                    hidden: Boolean(selectPairSelector),
                }), children: (0, jsx_runtime_1.jsx)(Form_1.default, { onSubmit: onSubmitToConfirmation, isDisabled: isDisabled, setSelectPairSelector: setSelectPairSelector }) }), selectPairSelector !== null ? ((0, jsx_runtime_1.jsx)("div", { className: "absolute top-0 left-0 h-full w-full bg-black rounded-lg overflow-hidden", children: (0, jsx_runtime_1.jsx)(FormPairSelector_1.default, { onSubmit: onSelectMint, onClose: () => setSelectPairSelector(null) }) })) : null] }));
};
exports.default = InitialScreen;
